import React from 'react';
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
// import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// Helper function to format a Date object as YYYY-MM-DD for input value
const formatDate = (date) => date.toISOString().split('T')[0];

// Helper function to get the date of a specific day index (0=Sunday, 1=Monday...)
// const getDateForDay = (startDate, dayIndex) => {
//   const date = new Date(startDate);
//   // Get the current day of the week (0=Sunday, 1=Monday, ..., 6=Saturday)
//   const currentDay = date.getDay(); 
  
//   // Calculate the difference in days to reach the target dayIndex (1=Mon, 2=Tue, etc.)
//   // We assume startDate is Monday (1), and we want to start the week on Monday.
  
//   // This calculates the difference in days from the start date (assumed to be Monday)
//   // to the target day of the week (dayIndex: 0=Mon, 1=Tue, 6=Sun)
//   date.setDate(date.getDate() + dayIndex); 
//   return date;
// };

// Helper function to find the most recent Monday before or on the current date
const getPreviousMonday = (date) => {
    const d = new Date(date);
    const day = d.getDay(); // 0 = Sunday, 1 = Monday
    const diff = d.getDate() - day + (day === 0 ? -6 : 1); // Adjust to get to Monday
    return new Date(d.setDate(diff));
};


/**
 * A component allowing users to input hours logged with week navigation.
 */
export function TimeLogForm({ title, initialData = {}, initialDate = new Date().toISOString(), reportIndex, updateReportInitialDate, updateReportHours, updateOrderButtonStatus }) {
  const daysOfWeek = ['MON', 'TUE', 'WED', 'THURS', 'FRI', 'SAT', 'SUN'];

  let initialStartDate = new Date(initialDate);

  let weekStartDate = formatDate(getPreviousMonday(initialStartDate));
  
  // Calculate the dates for the current week based on the weekStartDate
  const currentWeekDates = daysOfWeek.map((_, index) => {
    const date = new Date(weekStartDate + 'T00:00:00'); // Ensure we start from Monday of the selected week
    date.setDate(date.getDate() + index);
    return date;
  });

  // State for hours logged, keyed by the day abbreviation (MON, TUE, etc.)
  const initialLog = daysOfWeek.reduce((acc, day) => ({ 
    ...acc, 
    [day]: initialData[day] || 0 
  }), {});

  const handleOnFocus = (e) => {
    e.target.select();
  };

  // 🔄 Handler to update state based on the hour input's 'name'
  const handleChange = (e) => {
    const { name, value } = e.target;
    const numericValue = parseFloat(value) || 0; 

    updateReportHours(reportIndex, name, numericValue);
  };
  
  // 📆 Handler to update the start of the week when the date input changes
  const handleDateChange = (e) => {
    // When the user selects a new date, calculate the Monday of that week
    const selectedDate = new Date(e.target.value + 'T00:00:00');
    updateReportInitialDate(reportIndex, getPreviousMonday(selectedDate).toISOString());
  };

  return (
    <Container className="my-4">
      <Form>
        {title}
        
        {/* 1. Date Selector Above the Table */}
        <Row className="mb-3 align-items-end">
            <Col xs={12} md={4}>
                <Form.Group controlId="weekStartDate">
                    <Form.Label>Select Week Starting Date (Monday):</Form.Label>
                    <Form.Control
                        type="date"
                        value={weekStartDate}
                        onChange={handleDateChange}
                        disabled={updateOrderButtonStatus === 'edit' ? true : false}
                    />
                </Form.Group>
            </Col>
            <Col xs={12} md={8} className="text-md-end">
                <p className="lead m-0">
                    **Week:** {currentWeekDates[0].toLocaleDateString()} - {currentWeekDates[6].toLocaleDateString()}
                </p>
            </Col>
        </Row>

        <Table striped bordered responsive className="text-nowrap"> 
          <thead>
            {/* 2. New Header Row for Dates */}
            <tr>
              <th>Date</th> 
              {currentWeekDates.map((date, index) => (
                <th key={index} className="text-center small">
                  {/* Displays the short date: e.g., 11/25 */}
                  {date.toLocaleDateString(undefined, { month: 'numeric', day: 'numeric' })} 
                </th>
              ))}
            </tr>
            {/* Original Header Row for Days */}
            <tr>
              <th>Days of Week</th> 
              {daysOfWeek.map((day) => (
                <th key={day} className="text-center">{day}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <th style={{'background': 'white'}}>Hours Logged</th> 
              {daysOfWeek.map((day) => (
                <td key={day} className="p-0">
                  <Form.Control
                    type="number"
                    step="0.25"
                    min="0"
                    max="24"
                    name={day}
                    value={initialLog[day]}
                    onChange={handleChange}
                    onFocus={handleOnFocus}
                    className="text-center border-0"
                    required
                    disabled={updateOrderButtonStatus === 'edit' ? true : false}
                  />
                </td>
              ))}
            </tr>
          </tbody>
        </Table>
      </Form>
    </Container>
  );
}